import "jodit/build/jodit.min.css";
import Vue from "vue";
import JoditVue from "jodit-vue";

Vue.use(JoditVue, {
	language: "es",
	preset: "inline",
	toolbarAdaptive: false,
	enter: "DIV",
});

/*import Vue from 'vue';
import CKEditor from 'ckeditor4-vue';

Vue.use( CKEditor );*/
/*
import wysiwyg from "vue-wysiwyg";

import { API_URL } from '../constants'

let axiosHeaders = {
	Authorization: `${window.localStorage.getItem(
		"auth._token.local"
	)}`
};

Vue.use(wysiwyg, {
	// if the image option is not set, images are inserted as base64
	image: {
	  	uploadURL: API_URL + "/admin/upload-image2",
	  	dropzoneOptions: {
		  headers: axiosHeaders,

		}
	},
	forcePlainTextOnPaste: true,
	// limit content height if you wish. If not set, editor size will grow with content.
	maxHeight: "600px",
	// specify editor locale, if you don't specify this, the editor will default to english.
	locale: 'es'
}); // config is optional. more below
*/
